import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

export default function XLSIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ fill: '#34a853' }}>
      <g transform="scale(1.125) translate(3,3)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.222 0H1.778C.8 0 .008.8.008 1.778L0 4.444v9.778C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm0 7.111h-7.11v7.111H5.332v-7.11H1.778V5.332h3.555V1.778h1.778v3.555h7.111v1.778z"
        />
      </g>
    </SvgIcon>
  )
}
